import PopupBannerListPage from "./pages/PopupBannerListPage";
import PopupBannerDetailPage from "./pages/PopupBannerDetailPage";
import PopupBannerCreatePage from "./pages/PopupBannerCreatePage";

export const popupBannerRoutes = (prefix = "popup-banners") => [
  {
    name: "PopupBannerCreatePage",
    path: `${prefix}/create`,
    component: PopupBannerCreatePage
  },
  {
    name: "PopupBannerDetailPage",
    path: `${prefix}/:id`,
    component: PopupBannerDetailPage
  },
  {
    name: "PopupBannerListPage",
    path: prefix,
    component: PopupBannerListPage
  }
];
